import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, Transition as _Transition, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-e00e23fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "md:px-6 px-4 h-screen" }
const _hoisted_2 = { class: "my-4" }
const _hoisted_3 = {
  key: 2,
  class: "py-2 min-w-full min-h-max"
}
const _hoisted_4 = { class: "hidden lg:block" }
const _hoisted_5 = { class: "min-w-full divide-y divide-gray-200 shadow border-b border-gray-200 sm:rounded-lg" }
const _hoisted_6 = { class: "bg-gray-50" }
const _hoisted_7 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_8 = { class: "tableBodyItem" }
const _hoisted_9 = { class: "tableBodyItem" }
const _hoisted_10 = { class: "tableBodyItem" }
const _hoisted_11 = { class: "tableBodyItem" }
const _hoisted_12 = { class: "tableBodyItem" }
const _hoisted_13 = { class: "tableBodyItem" }
const _hoisted_14 = {
  key: 0,
  class: "tableBodyItem"
}
const _hoisted_15 = {
  key: 1,
  class: "tableBodyItem"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = {
  key: 2,
  class: "px-14 py-2 text-sm text-gray-500"
}
const _hoisted_18 = { class: "px-12 py-2 text-sm text-gray-500" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Open options", -1))
const _hoisted_20 = { class: "py-1" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { key: 0 }
const _hoisted_23 = ["href"]
const _hoisted_24 = { class: "text-lg leading-6 font-medium text-gray-900" }
const _hoisted_25 = { class: "inline-block align-bottom text-left sm:align-middle w-full pb-5" }
const _hoisted_26 = { class: "divide-y divide-gray-200 space-y-5" }
const _hoisted_27 = { class: "sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 pt-5" }
const _hoisted_28 = {
  for: "duration",
  class: "block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
}
const _hoisted_29 = { class: "mt-1 sm:mt-0 sm:col-span-2" }
const _hoisted_30 = { class: "sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 pt-5" }
const _hoisted_31 = {
  for: "camera-name",
  class: "block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
}
const _hoisted_32 = { class: "mt-1 sm:mt-0 sm:col-span-2" }
const _hoisted_33 = ["value"]
const _hoisted_34 = { class: "mt-1 pt-5" }
const _hoisted_35 = { class: "mt-1 pt-5" }
const _hoisted_36 = { class: "sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 pt-5" }
const _hoisted_37 = {
  for: "duration",
  class: "block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
}
const _hoisted_38 = { class: "mt-1 sm:mt-0 sm:col-span-2" }
const _hoisted_39 = { value: "1" }
const _hoisted_40 = { value: "2" }
const _hoisted_41 = { value: "3" }
const _hoisted_42 = { value: "4" }
const _hoisted_43 = { value: "5" }
const _hoisted_44 = { class: "pt-4 mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense" }
const _hoisted_45 = {
  class: "fixed z-50 inset-0 overflow-y-auto",
  "aria-labelledby": "modal-title",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_46 = { class: "flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "hidden sm:inline-block sm:align-middle sm:h-screen",
  "aria-hidden": "true"
}, "​", -1))
const _hoisted_48 = { class: "inline-block align-bottom text-left overflow-hidden shadow-xl transform transition-all sm:align-middle sm:w-full sm:max-w-screen-sm lg:max-w-screen-md 2xl:max-w-screen-2xl" }
const _hoisted_49 = { class: "mt-2" }

import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/vue";
import { PlusIcon, PlayIcon, XCircleIcon, EllipsisVerticalIcon } from "@heroicons/vue/24/solid";
import { format, parseISO } from "date-fns";
import { Form, GenericObject } from "vee-validate";
import { computed, onMounted, Ref, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import * as yup from "yup";
import LoadingSpinner from "shared/components/loading_state/LoadingSpinner.vue";
import Modal from "shared/components/modals/Modal.vue";
import { useCurrentCustomerName, useCurrentSiteId } from "shared/composables/project";
import { useCustomToast } from "shared/composables/toast";
import { useTrackEvent } from "shared/composables/tracking";
import logger from "shared/services/logger";
import { Stream } from "shared/types/Stream";
import DateField from "@/components/forms/DateField.vue";
import Field from "@/components/forms/Field.vue";
import PageHeader from "@/components/layout/PageHeader.vue";
import Sidebar from "@/components/layout/Sidebar.vue";
import MainButton from "@/components/other/MainButton.vue";
import OculaiVideoPlayer from "@/components/other/OculaiVideoPlayer.vue";
import { useStreams } from "@/composables/stream";
import CameraRepository from "@/repositories/CameraRepository";
import { CustomizableTimelapse } from "@/types/CustomizableTimelapse";
import CameraNavbar from "@/views/camera/components/CameraNavbar.vue";
import CustomTimeLapseMobile from "@/views/camera/components/CustomTimeLapseMobile.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomizableTimelapse',
  setup(__props) {

const timelapseVideos = ref([]) as Ref<CustomizableTimelapse[]>;
const open = ref(false) as Ref<boolean>;
const openVideoModal = ref(false) as Ref<boolean>;
const videoUrl = ref(null) as Ref<string | null>;
const cameraName = ref(null) as Ref<string | null>;

const duration = ref("1") as Ref<string | null>;
const tableHeaders = [
  "name",
  "camera",
  "start_date",
  "end_date",
  "duration",
  "created",
  "play",
  "extended",
];

const { streams, isLoading } = useStreams();
const { t } = useI18n();
const toast = useCustomToast();
const currentCustomerName = useCurrentCustomerName();
const currentSiteId = useCurrentSiteId();
const trackEvent = useTrackEvent();

const schema = computed(() =>
  yup.object({
    timelapse_name: yup
      .string()
      .required(t("camera.customizable_timelapse.errors.missing_name"))
      .test("unique-name", t("camera.customizable_timelapse.errors.unique_name"), (value) => {
        const existingNames = timelapseVideos.value.map((video) => video.name);
        return !existingNames.includes(value);
      }),
    start_date: yup
      .date()
      .nullable()
      .required(t("camera.customizable_timelapse.errors.missing_start_date"))
      .max(
        maxDate.value,
        t("err.err_future_date", { maxDate: format(maxDate.value, "yyyy-MM-dd") }),
      ),
    end_date: yup
      .date()
      .nullable()
      .required(t("camera.customizable_timelapse.errors.missing_end_date"))
      .max(
        maxDate.value,
        t("err.err_future_date", { maxDate: format(maxDate.value, "yyyy-MM-dd") }),
      )
      .test(
        "start-end-date",
        t("camera.customizable_timelapse.errors.end_date_before_start_date"),
        (value, { parent }) => {
          const startDateValue = parent.start_date;
          return value >= startDateValue;
        },
      ),
  }),
);

onMounted(() => {
  initializePage();
  trackEvent("camera_customizable-timelapse_view");
});

watch(isLoading, () => {
  getCamIDs();
});

const maxDate = computed(() => {
  return new Date();
});

const initializePage = () => {
  getCustomizableTimelapseUrl();
  getCamIDs();
};

const getCamIDs = () => {
  if (!isLoading.value) {
    cameraName.value =
      Array.isArray(streams.value) && streams.value.length > 0 ? streams.value[0].name : "";
  }
};

const getCustomizableTimelapseUrl = () => {
  CameraRepository.loadCustomizableTimelapses(currentCustomerName, currentSiteId)
    .then((customizableTimelapses) => {
      timelapseVideos.value = customizableTimelapses;
    })
    .catch((error) => {
      logger.error(error);
    });
};

const createIndividualTimelapse = (values: GenericObject) => {
  const stream: Stream | undefined = Array.isArray(streams.value)
    ? streams.value.find((element: Stream) => element.name === cameraName.value)
    : undefined;

  trackEvent("camera_customizable-timelapse_create");
  if (!stream) {
    return;
  }

  const customizableTimelapse: {
    name: string;
    start_date: Date;
    end_date: Date;
    duration: number;
    camera_id: string;
  } = {
    camera_id: stream.camera_id,
    name: values?.timelapse_name,
    start_date: parseISO(format(values?.start_date, "yyyy-MM-dd")),
    end_date: parseISO(format(values?.end_date, "yyyy-MM-dd")),
    duration: duration?.value ? parseInt(duration.value.substring(0, 1)) : 0,
  };
  CameraRepository.createCustomizableTimelapse(
    currentCustomerName,
    currentSiteId,
    customizableTimelapse,
  )
    .then((createdCustomizableTimelapse) => {
      timelapseVideos.value.unshift(createdCustomizableTimelapse);
      toast.success(t("camera.customizable_timelapse.success_notification.message"));
    })
    .catch((error) => {
      if (error?.response?.status === 400 && error.response.data?.code === "ALREADY_EXISTS") {
        toast.warning(t("camera.customizable_timelapse.errors.unique_name"));
      } else {
        toast.error(t("camera.customizable_timelapse.errors.create_error"));
        logger.error(error);
      }
    })
    .finally(() => {
      open.value = false;
    });
};

const deleteTimelapseVideo = (entry: CustomizableTimelapse) => {
  CameraRepository.deleteCustomizableTimelapse(currentCustomerName, currentSiteId, entry._id)
    .then(() => {
      const index = timelapseVideos.value.findIndex((video) => video._id === entry._id);
      timelapseVideos.value.splice(index, 1);
    })
    .catch((error) => {
      logger.error(error);
    });

  trackEvent("camera_customizable-timelapse_delete");
};

const initializePlayer = (url: string) => {
  openVideoModal.value = true;
  videoUrl.value = url;
};
const submitted = ref(false) as Ref<boolean>;
const closeModal = () => {
  submitted.value = false;
  openVideoModal.value = false;
};

const formatDate = (date: Date) => {
  return format(date, "dd.MM.yyyy");
};

const formatDateWithTime = (date: Date) => {
  return format(date, "dd.MM.yyyy HH:mm:ss");
};
const closeCreateModal = () => {
  open.value = false;
};

const route = useRoute();

const currentStream = computed(() =>
  streams.value.find((stream) => stream.camera_id === route.params.camera_id),
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Sidebar, { class: "h-full" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (currentStream.value)
          ? (_openBlock(), _createBlock(PageHeader, { key: 0 }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(currentStream.value.name), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (currentStream.value)
          ? (_openBlock(), _createBlock(CameraNavbar, {
              key: 1,
              stream: currentStream.value
            }, null, 8, ["stream"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(MainButton, {
            onClicked: _cache[0] || (_cache[0] = ($event: any) => (open.value = true)),
            color: "yellow",
            label: _unref(t)('camera.customizable_timelapse.create_button')
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(PlusIcon), {
                class: "-ml-1 mr-3 h-5 w-5",
                "aria-hidden": "true"
              })
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        (timelapseVideos.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("table", _hoisted_5, [
                  _createElementVNode("thead", _hoisted_6, [
                    _createElementVNode("tr", null, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tableHeaders, (header) => {
                        return _createElementVNode("th", {
                          key: header,
                          scope: "col",
                          class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                        }, _toDisplayString(_ctx.$t(`camera.customizable_timelapse.table.${header}`)), 1)
                      }), 64))
                    ])
                  ]),
                  _createElementVNode("tbody", _hoisted_7, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(timelapseVideos.value, (entry) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: entry._id
                      }, [
                        _createElementVNode("td", _hoisted_8, _toDisplayString(entry.name), 1),
                        _createElementVNode("td", _hoisted_9, _toDisplayString(_unref(streams).find((stream) => stream.camera_id === entry.camera_id)?.name ||
                    entry.camera_id), 1),
                        _createElementVNode("td", _hoisted_10, _toDisplayString(formatDate(entry.start_date)), 1),
                        _createElementVNode("td", _hoisted_11, _toDisplayString(formatDate(entry.end_date)), 1),
                        _createElementVNode("td", _hoisted_12, _toDisplayString(entry.duration) + _toDisplayString(_ctx.$t("camera.customizable_timelapse.table.duration_min")), 1),
                        _createElementVNode("td", _hoisted_13, _toDisplayString(formatDateWithTime(entry.created)), 1),
                        (entry.status === 'generating')
                          ? (_openBlock(), _createElementBlock("td", _hoisted_14, [
                              _createVNode(LoadingSpinner, { class: "h-4 w-4" })
                            ]))
                          : (entry.status === 'ready')
                            ? (_openBlock(), _createElementBlock("td", _hoisted_15, [
                                _createElementVNode("button", {
                                  onClick: ($event: any) => (initializePlayer(entry.url ?? '')),
                                  type: "button",
                                  class: "inline-flex items-center px-4 py-1 border border-transparent shadow-sm text-base font-medium rounded-md text-white bg-yellow-500 hover:bg-yellow-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500"
                                }, [
                                  _createVNode(_unref(PlayIcon), {
                                    class: "-ml-1 mr-3 h-5 w-5",
                                    "aria-hidden": "true"
                                  }),
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t("camera.customizable_timelapse.table.play_button")), 1)
                                ], 8, _hoisted_16)
                              ]))
                            : (_openBlock(), _createElementBlock("td", _hoisted_17, [
                                _createVNode(_unref(XCircleIcon), {
                                  class: "-ml-1 mr-3 h-6 w-6 text-orange-400",
                                  "aria-hidden": "true"
                                })
                              ])),
                        _createElementVNode("td", _hoisted_18, [
                          _createVNode(_unref(Menu), {
                            as: "div",
                            class: "relative inline-block text-left"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", null, [
                                _createVNode(_unref(MenuButton), { class: "rounded-full flex items-center text-gray-400 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-yellow-300" }, {
                                  default: _withCtx(() => [
                                    _hoisted_19,
                                    _createVNode(_unref(EllipsisVerticalIcon), {
                                      class: "h-5 w-5",
                                      "aria-hidden": "true"
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createVNode(_Transition, {
                                "enter-active-class": "transition ease-out duration-100",
                                "enter-from-class": "transform opacity-0 scale-95",
                                "enter-to-class": "transform opacity-100 scale-100",
                                "leave-active-class": "transition ease-in duration-75",
                                "leave-from-class": "transform opacity-100 scale-100",
                                "leave-to-class": "transform opacity-0 scale-95"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(MenuItems), { class: "z-50 absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-2 ring-gray/5 focus:outline-none" }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_20, [
                                        _createVNode(_unref(MenuItem), null, {
                                          default: _withCtx(({ active }) => [
                                            _createElementVNode("a", {
                                              href: "#",
                                              onClick: _withModifiers(($event: any) => (deleteTimelapseVideo(entry)), ["prevent"]),
                                              class: _normalizeClass([
                                active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                                'block px-4 py-2 text-sm',
                              ])
                                            }, _toDisplayString(_ctx.$t("camera.customizable_timelapse.table.extended_remove")), 11, _hoisted_21)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        (entry.url)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                              _createVNode(_unref(MenuItem), null, {
                                                default: _withCtx(({ active }) => [
                                                  _createElementVNode("a", {
                                                    href: entry.url,
                                                    class: _normalizeClass([
                                  active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                                  'block px-4 py-2 text-sm',
                                ])
                                                  }, _toDisplayString(_ctx.$t("camera.customizable_timelapse.table.extended_download")), 11, _hoisted_23)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              _createVNode(CustomTimeLapseMobile, {
                timelapseVideos: timelapseVideos.value,
                onPlayVideo: _cache[1] || (_cache[1] = ($event: any) => (initializePlayer($event))),
                onDeleteTimelapseVideo: _cache[2] || (_cache[2] = ($event: any) => (deleteTimelapseVideo($event)))
              }, null, 8, ["timelapseVideos"])
            ]))
          : _createCommentVNode("", true),
        _createVNode(Modal, {
          open: open.value,
          onClose: closeCreateModal,
          customCls: "w-full sm:max-w-lg "
        }, {
          title: _withCtx(() => [
            _createElementVNode("h3", _hoisted_24, _toDisplayString(_ctx.$t("camera.customizable_timelapse.create_modal.title")), 1)
          ]),
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_25, [
              _createVNode(_unref(Form), {
                onSubmit: createIndividualTimelapse,
                class: "space-y-8 divide-y divide-gray-200",
                validationSchema: schema.value
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("label", _hoisted_28, _toDisplayString(_unref(t)("camera.customizable_timelapse.create_modal.timelapse_name")), 1),
                      _createElementVNode("div", _hoisted_29, [
                        _createVNode(Field, {
                          name: "timelapse_name",
                          autofocus: true
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("label", _hoisted_31, _toDisplayString(_ctx.$t("camera.customizable_timelapse.create_modal.camera")), 1),
                      _createElementVNode("div", _hoisted_32, [
                        _withDirectives(_createElementVNode("select", {
                          id: "camera-name",
                          name: "camera_name",
                          autocomplete: "camera-name",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((cameraName).value = $event)),
                          class: "oai-inputs"
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(streams), (stream) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: stream._id,
                              value: stream.name
                            }, _toDisplayString(stream.name), 9, _hoisted_33))
                          }), 128))
                        ], 512), [
                          [_vModelSelect, cameraName.value]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      _createVNode(DateField, {
                        name: "start_date",
                        label: _ctx.$t('camera.period.date'),
                        maxDate: maxDate.value,
                        inlineField: true
                      }, null, 8, ["label", "maxDate"])
                    ]),
                    _createElementVNode("div", _hoisted_35, [
                      _createVNode(DateField, {
                        name: "end_date",
                        label: _ctx.$t('camera.customizable_timelapse.create_modal.end'),
                        maxDate: maxDate.value,
                        inlineField: true
                      }, null, 8, ["label", "maxDate"])
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.$t("camera.customizable_timelapse.create_modal.duration")), 1),
                      _createElementVNode("div", _hoisted_38, [
                        _withDirectives(_createElementVNode("select", {
                          id: "duration",
                          name: "duration",
                          autocomplete: "duration",
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((duration).value = $event)),
                          class: "oai-inputs"
                        }, [
                          _createElementVNode("option", _hoisted_39, _toDisplayString(_ctx.$t("camera.customizable_timelapse.create_modal.option_1")), 1),
                          _createElementVNode("option", _hoisted_40, _toDisplayString(_ctx.$t("camera.customizable_timelapse.create_modal.option_2")), 1),
                          _createElementVNode("option", _hoisted_41, _toDisplayString(_ctx.$t("camera.customizable_timelapse.create_modal.option_3")), 1),
                          _createElementVNode("option", _hoisted_42, _toDisplayString(_ctx.$t("camera.customizable_timelapse.create_modal.option_4")), 1),
                          _createElementVNode("option", _hoisted_43, _toDisplayString(_ctx.$t("camera.customizable_timelapse.create_modal.option_5")), 1)
                        ], 512), [
                          [_vModelSelect, duration.value]
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    _createVNode(MainButton, {
                      label: _unref(t)('camera.customizable_timelapse.create_modal.create'),
                      color: "yellow",
                      type: "submit",
                      class: "w-full sm:order-2 sm:col-start-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(PlusIcon), {
                          class: "-ml-1 mr-3 h-4 w-4",
                          "aria-hidden": "true"
                        })
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(MainButton, {
                      label: _unref(t)('camera.customizable_timelapse.create_modal.cancel'),
                      bordered: "true",
                      onClicked: _cache[5] || (_cache[5] = ($event: any) => (open.value = false)),
                      class: "w-full sm:order-1 sm:col-start-1 sm:col-end-1"
                    }, null, 8, ["label"])
                  ])
                ]),
                _: 1
              }, 8, ["validationSchema"])
            ])
          ]),
          _: 1
        }, 8, ["open"]),
        _withDirectives(_createElementVNode("div", _hoisted_45, [
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("div", {
              class: "fixed inset-0 bg-gray-500/75 transition-opacity",
              onClick: closeModal,
              "aria-hidden": "true"
            }),
            _hoisted_47,
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("div", _hoisted_49, [
                (openVideoModal.value)
                  ? (_openBlock(), _createBlock(OculaiVideoPlayer, {
                      key: 0,
                      src: videoUrl.value
                    }, null, 8, ["src"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ], 512), [
          [_vShow, openVideoModal.value]
        ])
      ])
    ]),
    _: 1
  }))
}
}

})